module.exports = __webpack_public_path__ + "img/icon3.69f6839d.png";